import React, { useState } from 'react'
import './modal.css'

export default function DemanderDevisModal({ showModal, setShowModal }) {
    return (
        <div id="myModal" style={{ display: showModal ? 'block' : 'none' }} className="modal">
            <div className="modal-content">
                <h1 className='form-title'>Formulaire demander un devis</h1>

                <div className="input-area">
                    <label htmlFor="entreprise">Nom de l'entreprise: </label>
                    <input type="text" className='form-element' name="entreprise" placeholder="Nom de l'entreprise" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Secteur d'activite: </label>
                    <input type="text" className='form-element' name="secteur" placeholder="Secteur d'activite" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Contact: </label>
                    <input type="text" className='form-element' name="contact" placeholder="Contact" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Volume de signature: </label>
                    <input type="text" className='form-element' name="volume" placeholder="Volume de signature" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Description du besoin: </label>
                    <textarea className='form-element-textarea' name="description" placeholder="Description du besoin" />
                </div>

                <div className="form-button-container">
                    <div 
                        onClick={() => setShowModal(false)}
                        style={{backgroundColor: '#ed3939cc'}} 
                        className="landing-tarif__pack-item-btn">
                            Annuler
                    </div>

                    <div 
                        onClick={() => setShowModal(false)}
                        className="landing-tarif__pack-item-btn">
                            Valider
                    </div>
                </div>
            </div>
        </div>
    )
}

